import React from "react";

const UnlinkIcon = React.forwardRef(
  (
    {
      width = "20",
      height = "20",
      viewBox = "0 0 20 20",
      fill = "none",
      strokeColor = "#344054",
      className,
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1_9177)">
          <g clip-path="url(#clip1_1_9177)">
            <path
              d="M7.49996 3.33329V1.66663M12.5 16.6666V18.3333M3.33329 7.49996H1.66663M16.6666 12.5H18.3333M4.09514 4.09514L2.91663 2.91663M15.9048 15.9048L17.0833 17.0833M9.99996 14.714L8.23219 16.4818C6.93044 17.7835 4.81989 17.7835 3.51815 16.4818C2.2164 15.18 2.2164 13.0695 3.51815 11.7677L5.28591 9.99996M14.714 9.99996L16.4818 8.23219C17.7835 6.93044 17.7835 4.81989 16.4818 3.51815C15.18 2.2164 13.0695 2.2164 11.7677 3.51815L9.99996 5.28591"
              stroke={strokeColor}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1_9177">
            <rect width="20" height="20" fill="white" />
          </clipPath>
          <clipPath id="clip1_1_9177">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

export default UnlinkIcon;
